import { useTranslation } from '@hooks/useTranslation';
import { Send } from '@mui/icons-material';
import { Box, IconButton, TextField, TextFieldProps } from '@mui/material';
import { styled } from '@mui/system';
import React from 'react';
import WolfTooltip from './WolfTooltip';

const StyledTextField = styled(TextField)<TextFieldProps>(({ theme }) => ({
  '& .MuiInputBase-root': {
    boxSizing: 'border-box',
    padding: '0',
    '& .MuiInputBase-input': {
      padding: '0',
      boxSizing: 'border-box',
    },
  },
  '& .MuiInputLabel-root': {
    display: 'none',
  },
  '& .MuiOutlinedInput-root': {
    border: 'none',
    transition: 'border-color 0.3s ease',
    '&:hover': {
      border: 'none',
    },
    '&.Mui-focused': {
      outline: 'none',
    },
    '&.Mui-focused fieldset': {
      border: 'none',
    },
    '&.Mui-error fieldset': {
      border: 'none',
    },
    '&.Mui-disabled fieldset': {
      color: theme.palette.grey[500],
      border: 'none',
      background: theme.palette.action.disabledBackground,
    },
    '& fieldset': {
      border: 'none',
    },
  },
}));

interface WolfFullTextareaProps {
  value: string;
  onChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onSubmit: (event: React.FormEvent) => void;
  placeholder?: string;
  disabled?: boolean;
  autoFocus?: boolean;
}

const WolfFullTextarea: React.FC<WolfFullTextareaProps> = ({
  value,
  onChange,
  onSubmit,
  placeholder,
  disabled = false,
  autoFocus = false,
}) => {
  const localeWolfie = useTranslation('wolfie');

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && (e.ctrlKey || e.metaKey)) {
      e.preventDefault();
      onSubmit(e as any);
    }
  };

  return (
    <Box className="relative w-full">
      <StyledTextField
        fullWidth
        multiline
        minRows={1}
        maxRows={5}
        value={value}
        onChange={onChange}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        disabled={disabled}
        autoFocus={autoFocus}
        InputProps={{
          endAdornment: (
            <WolfTooltip title={localeWolfie['send']}>
              <span>
              <IconButton onClick={onSubmit} disabled={disabled} color="primary" className="absolute bottom-0 right-0">
                <Send />
              </IconButton>
              </span>
            </WolfTooltip>
          ),
        }}
      />
    </Box>
  );
};

export default WolfFullTextarea;
